"use strict"

import React from "react"
import { SketchPicker, CirclePicker } from "react-color"

import "./styles.scss"

export const ColorPicker = ({ handleChangeColor, color }) => {
  return <SketchPicker color={color} onChange={handleChangeColor} />
}

export const CirclePickerColor = ({ handleChangeColor }) => {
  const colors = ["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#82CD47", "#5DA7DB", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b", "#00ABB3", "#EA047E", "#A77979", "#150050", "#F675A8", "#A66CFF"]
  return <CirclePicker colors={colors} className="circle-color mt-20" onChange={handleChangeColor} />
}
